import React from 'react';

const Dashboard = ({ currentUser, dashboardStats, isLoadingDashboard, onRefreshDashboard }) => {
  const formatAmount = (value) => `₹${Number(value || 0).toLocaleString('en-IN')}`;

  const stats = dashboardStats || {};
  const storeWiseStats = Array.isArray(stats.storeWiseStats) ? stats.storeWiseStats : [];

  const cardItems = [
    { label: 'Total Stores', value: stats.totalStores ?? 0, icon: 'fa-store', color: 'text-blue-600' },
    { label: 'Active Stores', value: stats.activeStores ?? 0, icon: 'fa-store-alt', color: 'text-green-600' },
    { label: 'Advances Today', value: stats.totalAdvancesToday ?? 0, icon: 'fa-receipt', color: 'text-purple-600' },
    { label: 'Amount Today', value: formatAmount(stats.totalAmountToday), icon: 'fa-rupee-sign', color: 'text-red-600' },
    { label: 'Advances This Month', value: stats.totalAdvancesThisMonth ?? 0, icon: 'fa-calendar-alt', color: 'text-indigo-600' },
    { label: 'Amount This Month', value: formatAmount(stats.totalAmountThisMonth), icon: 'fa-wallet', color: 'text-orange-600' },
    { label: 'Latest Gold Rate 22K', value: formatAmount(stats.latestGoldRate22K), icon: 'fa-coins', color: 'text-amber-600' },
  ];

  return (
    <section className="space-y-4 md:space-y-6">
      <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-3">
          <div>
            <h2 className="text-xl md:text-2xl font-bold">Dashboard</h2>
            <p className="text-sm text-gray-500 mt-1">Welcome, {currentUser?.name || currentUser?.loginId || 'User'}</p>
          </div>
          <button
            onClick={onRefreshDashboard}
            disabled={isLoadingDashboard}
            className="inline-flex items-center justify-center gap-2 bg-jewel-red text-white px-4 py-2 rounded-lg font-bold hover:bg-red-700 transition text-sm md:text-base disabled:bg-gray-400 disabled:cursor-not-allowed"
          >
            <i className="fas fa-sync-alt"></i>
            <span>{isLoadingDashboard ? 'Refreshing...' : 'Refresh'}</span>
          </button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-4 gap-4">
        {cardItems.map((item) => (
          <div key={item.label} className="bg-white p-4 rounded-lg shadow-sm border border-gray-200">
            <div className="flex items-center justify-between mb-3">
              <p className="text-xs uppercase font-bold text-gray-500 tracking-wide">{item.label}</p>
              <i className={`fas ${item.icon} ${item.color}`}></i>
            </div>
            <p className="text-2xl font-bold text-gray-900">{item.value}</p>
          </div>
        ))}
      </div>

      <div className="bg-white p-4 md:p-6 rounded-lg shadow-sm border border-gray-200">
        <h3 className="text-sm md:text-base font-bold uppercase text-gray-500 mb-4">Store Wise Statistics</h3>

        {isLoadingDashboard ? (
          <div className="text-center py-10 text-gray-500">Loading dashboard statistics...</div>
        ) : storeWiseStats.length === 0 ? (
          <div className="text-center py-10 text-gray-400">No store statistics available</div>
        ) : (
          <div className="overflow-x-auto -mx-4 md:mx-0">
            <table className="w-full text-left border-collapse min-w-[620px]">
              <thead>
                <tr className="bg-gray-100">
                  <th className="p-2 md:p-3 border text-xs md:text-sm">Store Code</th>
                  <th className="p-2 md:p-3 border text-xs md:text-sm">Store Name</th>
                  <th className="p-2 md:p-3 border text-xs md:text-sm text-right">Advances</th>
                  <th className="p-2 md:p-3 border text-xs md:text-sm text-right">Total Amount</th>
                </tr>
              </thead>
              <tbody>
                {storeWiseStats.map((item, index) => (
                  <tr key={`${item.storeCode}-${index}`}>
                    <td className="p-2 md:p-3 border text-xs md:text-sm">{item.storeCode}</td>
                    <td className="p-2 md:p-3 border text-xs md:text-sm">{item.storeName}</td>
                    <td className="p-2 md:p-3 border text-xs md:text-sm text-right">{item.advancesCount}</td>
                    <td className="p-2 md:p-3 border text-xs md:text-sm text-right">{formatAmount(item.totalAmount)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </section>
  );
};

export default Dashboard;
